import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DocketService} from './docket.service';
import {LocationService} from './location.service';
import {IMyDateModel} from 'mydatepicker';
import {AppComponent} from './app.component';

import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';

@Component({
    selector: 'location-docket',
    templateUrl: './templates/location-docket.component.html',
    styleUrls: ['./styles/products-list.component.css','./styles/location-docket.component.css'],
    providers: [DocketService, LocationService, SortTable]
})
export class LocationDocketComponent implements OnInit {
    docket_name: string = "";
    date = "";
    operation = 'IN';
    docket_list: any;

    docket_details_list: any;
    id_selected_docket: number;
    docket_infos: string = "";
    total_price: string = '0';

    disabled_modify_bt = true;
    operation_bt: string = "Placer";
    operation_bt_2: string = "Imprimer";

    docket_to_place: any;
    sortedData: any = [];

    constructor(
        private app_component: AppComponent,
        private router: Router,
        private docket_service: DocketService,
        private location_service: LocationService,
        private sort_table: SortTable
    ) {
        this.app_component.valTest = 'location-management';
        this.app_component.GetParent();
    }

    ngOnInit() {
        this.showEntrees();
    }

    placer() {
        this.router.navigate(['location', {id_docket: this.id_selected_docket}]);
    }

    GetDocketDetails(docket: any): void {
        this.docket_to_place = docket;
        this.id_selected_docket = docket.id_docket;

        this.docket_infos = ' ( ' + docket.reference_code + ' - ' + docket.docket_name + ' / ' + docket.timestamp + ' / ' + docket.operation + ' )';
        this.docket_service.GetDocketDetails(docket.id_docket)
            .then(result => {
                this.docket_details_list = result['list']; this.total_price = result['total_price']; this.Init();
            });
    }

    Init(): void {
        this.disabled_modify_bt = false;
        this.operation_bt = 'Placer';
        this.operation_bt_2 = 'Imprimer';
    }

    showEntrees(): void {
        this.location_service.getUnplacedItems(this.docket_name, this.date)
            .then(list => {
                this.docket_list = list['unplaced_dockets'];
                this.sortedData = list['unplaced_dockets'];
                this.sort_table.SetDataArray(list['unplaced_dockets'], [{value: "reference_code", type: ""}, {value: "docket_name", type: ""}, {value: "operation", type: ""}, {value: "timestamp", type: ""}]);
            });
    }

    Sort(sort: Sort): void {
        this.sort_table.sortData(sort);
        this.sortedData = this.sort_table.GetSortData();
        // recupérer  data
    }

    onDateChanged(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.date = "";
        } else {
            this.date = event.jsdate.toLocaleDateString("en-US");
        }
        this.showEntrees();
    }

    operationBt(): void {
        this.placer();
    }


    FormatPrice(price: any): string {
        return Math.round(price).toLocaleString() + ' Ar';
    }
}



// WEBPACK FOOTER //
// ./src/app/location-docket.component.ts